package horcrux.frontend.common.views.components.input

import mui.material.Stack
import mui.material.StackDirection
import mui.system.PropsWithSx
import mui.system.responsive
import mui.system.sx
import react.FC
import react.IntrinsicType
import react.dom.html.HTMLAttributes
import react.dom.html.ReactHTML.h2
import web.cssom.JustifyContent
import web.html.HTMLHeadingElement

external interface InstructionsWithHelpProps : PropsWithSx {
    var id: String
    var instructions: String
    var helpText: String
    var textTagSupplierMaybe: (() -> IntrinsicType<HTMLAttributes<HTMLHeadingElement>>)?
}

val InstructionsWithHelp = FC<InstructionsWithHelpProps> { props ->
    Stack {
        this.direction = responsive(StackDirection.row)
        this.sx {
            +props.sx
            this.justifyContent = JustifyContent.center
        }
        val textTag = props.textTagSupplierMaybe?.let { it() } ?: h2
        textTag { +props.instructions }
        InfoPopover {
            this.id = props.id
            this.text = props.helpText
        }
    }
}
